import { BaasicInput, BaasicWarningModal, SliderCheckBox, BaasicSelect, BaasicDropdown } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { channelType } from 'common/constants';
import React from 'react';
import ReactTooltip from 'react-tooltip';

const VirtualSKUStepTemplate = ({
	t,
	form,
	productEditViewStore: {
		onDelete,
		addVirtualSku,
		conflictWarningModal,
		checkValidity,
		channelOptions,
		onChange,
		disableUpdateInventory,
		setVirtualSkuActivity,
		isActive,
		rootStore,
		channel,
	},
}) => {
	return (
		<React.Fragment>
			<div className="row">
				<div className="col col-sml-12 col-xxlrg-10">
					<div className="flex--secondary">
						<h3 className="spc--bottom--med title--primary">{t('PRODUCT.WIZARD.VIRTUALSKUSTEP')}</h3>
						<button className="btn btn--med btn--secondary spc--bottom--sml" onClick={addVirtualSku} type="button">
							<i className="fa fa-plus spc--right--sml"></i> {t('PRODUCTVIEW.PRODUCTVIRTUALSKUADD')}
						</button>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col col-sml-12 col-lrg-12 col-xxlrg-10 spc--bottom--tny">
					{form.$('productVirtualSkus').map(productVirtualSkuField => {
						return (
							<div className="box--secondary box--sml spc--bottom--tny" key={productVirtualSkuField.key}>
								<div className="row">
									<div className="col col-sml-12">
										<div className="inputgroup type--right">
											<button
												className="btn btn--med btn--ghost react-filter-box-close"
												onClick={e => onDelete(e, productVirtualSkuField, form.$('productVirtualSkus'))}
												type="button"
											>
												<i className="fa fa-times"></i>
											</button>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col col-sml-12 col-lrg-2 col-xxlrg-2">
										<BaasicInput onValueChange={checkValidity} field={productVirtualSkuField.$('sku')} />
									</div>
									<div className="col col-sml-12 col-lrg-3 col-xxlrg-2">
										<BaasicSelect
											field={productVirtualSkuField.$('channel')}
											clearable={false}
											options={channelOptions}
											value={productVirtualSkuField.$('channel').value}
											onChange={value =>
												onChange(value, productVirtualSkuField.$('channel'), false, true, productVirtualSkuField)
											}
											disabled={channel && channel.id === productVirtualSkuField.$('channel').value.value}
										/>
									</div>
									<div className="col col-sml-12 col-lrg-3 col-xxlrg-3">
										<BaasicDropdown
											dropdownStore={productVirtualSkuField.carrierDropdownStore}
											isDisabled={
												productVirtualSkuField.$('channel').value == null ||
												productVirtualSkuField.$('channel').value == '' ||
												(productVirtualSkuField.$('channel').value.extra != null &&
													productVirtualSkuField.$('channel').value.extra.channelType != null &&
													productVirtualSkuField.$('channel').value.extra.channelType.name == channelType.amazonVendor)
											}
											additionalLabel={() => (
												<CarrierDropdownTooltip
													channel={productVirtualSkuField.$('channel').value}
													rootStore={rootStore}
												/>
											)}
										/>
									</div>
									<div className="col col-sml-12 col-lrg-2 col-xxlrg-2">
										<BaasicInput field={productVirtualSkuField.$('description')} />
									</div>
									<div className="col col-sml-12 col-lrg-2 col-xxlrg-3">
										<div className="input--toggle--custom display--ib spc--right--med">
											<div
												data-tip={!isActive ? t('PRODUCT.WIZARD.MAINSKUDISABLEDOPTION') : null}
												className="input--toggle--custom display--ib spc--right--med"
											>
												<SliderCheckBox
													onValueChange={value =>
														setVirtualSkuActivity(value, productVirtualSkuField.$('postInventory'))
													}
													disabled={!isActive}
													field={productVirtualSkuField.$('isActive')}
												/>
											</div>
										</div>
										<div
											data-tip={
												!isActive ||
												(productVirtualSkuField.$('isActive') != null && !productVirtualSkuField.$('isActive').value) ||
												disableUpdateInventory(productVirtualSkuField.$('channel').value)
													? !isActive
														? t('PRODUCT.WIZARD.MAINSKUDISABLEDOPTION')
														: productVirtualSkuField.$('isActive') != null &&
														  !productVirtualSkuField.$('isActive').value
														? t('PRODUCT.WIZARD.VIRTUALSKUDISABLEDOPTION')
														: t('PRODUCT.WIZARD.POSTINVENTORYCHANNELOFF')
													: ''
											}
											className="input--toggle--custom display--ib spc--right--med"
										>
											<SliderCheckBox
												disabled={
													!isActive ||
													!productVirtualSkuField.$('isActive').value ||
													disableUpdateInventory(productVirtualSkuField.$('channel').value)
												}
												field={productVirtualSkuField.$('postInventory')}
											/>
											<ReactTooltip />
										</div>
										{productVirtualSkuField.$('channel').value.extra != null &&
											productVirtualSkuField.$('channel').value.extra.channelType != null &&
											productVirtualSkuField.$('channel').value.extra.channelType.name == channelType.amazon && (
												<div className="input--toggle--custom display--ib">
													<SliderCheckBox field={productVirtualSkuField.$('isNonPrime')} />
												</div>
											)}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
			<BaasicWarningModal modalParams={conflictWarningModal} />
			<ReactTooltip />
		</React.Fragment>
	);
};

// Cant find a way to add the anchor to make it work with the translation file
const CarrierDropdownTooltip = ({ channel, rootStore }) => {
	if (channel != null) {
		return (
			<i className="fas fa-exclamation-circle spc--left--tny tooltip">
				<div className="tooltip">
					If you can't find the desired carrier for the SKU, make sure it's enabled for{' '}
					<a
						className="type--color--negative type--underline type--wgt--bold"
						onClick={() => {
							rootStore.routerStore.goTo('master.app.main.channel.edit', {
								id: channel.value,
							});
						}}
					>
						{channel.label}
					</a>{' '}
					channel on the Channels page
				</div>
			</i>
		);
	}
};

export default defaultTemplate(VirtualSKUStepTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/wizard/pages/VirtualSKUStepTemplate.jsx